<template>
  <div style="width: 100%">
		<!-- <iframe  
		scrolling="no"
		ref="iframe"  
		:src="src" frameborder="0" 
		style="width:100%;height: 100%;">
		</iframe> -->
		<iframe width="100%"  :src="src" frameborder="0" scrolling="no" id="test" :onload="reinitIframe"></iframe>
  </div>
</template>

<script>

	export default{
		data(){
			return{
				timer:null,
				showSessiconId:'',
				src:'xsx/xsx02.html'
			}
		},
		// components:{ Page },
		methods:{
			onloada(){
				
			},
			reinitIframe(){
				var iframe = document.getElementById("test");
				try{
				var bHeight = iframe.contentWindow.document.body.scrollHeight;
				var dHeight = iframe.contentWindow.document.documentElement.scrollHeight;var height = Math.max(bHeight, dHeight);
				iframe.height = height;}
				catch (ex){}
		    },
			godetail(data){
				
			this.$router.push(
				{path:'xsxDeyail',
				query:{
					id:data.id
				}
			})
		}
		  },
		mounted(){
			let that=this
			window["goBack"] = (data) => {
				  that.godetail(data)
				};
        
			if (this.timer==null) {
				this.timer=setInterval(()=>{
				var iframe = document.getElementById("test");
				try{
				var bHeight = iframe.contentWindow.document.body.scrollHeight;
				var dHeight = iframe.contentWindow.document.documentElement.scrollHeight;
				
			
				
				var height = Math.max(bHeight, dHeight);
				iframe.height = bHeight;
                
				}catch (ex){}
					
			}, 500)
			}
		},
		created() {
			this.$emit("highLight",0,"","","");
		},
		beforeDestroy () {
			//清除定时器
			clearInterval(this.timer);
			this.timer = null;
		},
		
		
	}
</script>

<style scoped>

		
			
</style>
